import { render, staticRenderFns } from "./component.vue?vue&type=template&id=1261afa4&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=1261afa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1261afa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1261afa4')) {
      api.createRecord('1261afa4', component.options)
    } else {
      api.reload('1261afa4', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=1261afa4&scoped=true&", function () {
      api.rerender('1261afa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/resource/component/project-card/component.vue"
export default component.exports